import { userApi } from "./http";

// ─── Intelligence ─────────────────────────────────────────────────────────────
/**
 * Fetch AI intelligence for a booking from UserCase via backend transform.
 * @returns {{ hasIntelligence, summary, checklist, insights, drafts, keywords, category, confidence, generatedAt }}
 */
export async function fetchIntelligence(bookingId) {
  console.log('[AI SERVICE] GET', `/ai/intelligence/${encodeURIComponent(bookingId)}`, '| bookingId type:', typeof bookingId, '| value:', bookingId);
  const { data } = await userApi.get(
    `/ai/intelligence/${encodeURIComponent(bookingId)}`
  );
  console.log("INTELLIGENCE RESPONSE =", data);
  return data;
}

// ─── Case Acceptance (reuses existing booking endpoint) ──────────────────────
export async function acceptBooking(bookingId) {
  const { data } = await userApi.patch(`/bookings/${bookingId}/status`, { status: "accepted" });
  return data;
}

export async function rejectBooking(bookingId) {
  const { data } = await userApi.patch(`/bookings/${bookingId}/status`, { status: "rejected" });
  return data;
}

// ─── AI Case Chat ─────────────────────────────────────────────────────────────
/**
 * Send a message to the AI case assistant.
 * @returns {{ reply, sources }}
 */
export async function sendChatMessage(bookingId, message) {
  const { data } = await userApi.post("/ai/case-chat", { bookingId, message });
  return data;
}

// ─── Document Management ──────────────────────────────────────────────────────
/**
 * Upload a file for a booking.
 * @param {string} bookingId
 * @param {File} file - native File object from input[type=file]
 * @returns {{ document: { id, file_name, file_url, file_size, mime_type, uploaded_at } }}
 */
export async function uploadCaseDocument(bookingId, file) {
  const form = new FormData();
  form.append("file", file);
  const { data } = await userApi.post(
    `/ai/documents/${encodeURIComponent(bookingId)}`,
    form,
    { headers: { "Content-Type": "multipart/form-data" } }
  );
  return data;
}

/**
 * List all documents uploaded for a booking.
 * @returns {{ documents: Array<{ id, file_name, file_url, file_size, mime_type, uploaded_at }> }}
 */
export async function fetchCaseDocuments(bookingId) {
  const { data } = await userApi.get(`/ai/documents/${encodeURIComponent(bookingId)}`);
  return data;
}

/**
 * Delete a specific document.
 */
export async function deleteCaseDocument(bookingId, docId) {
  const { data } = await userApi.delete(
    `/ai/documents/${encodeURIComponent(bookingId)}/${encodeURIComponent(docId)}`
  );
  return data;
}

/**
 * Download a document — triggers a file-save via a hidden anchor.
 * Uses the userApi axios instance so the auth token is included.
 */
export async function downloadCaseDocument(bookingId, docId, fileName) {
  const response = await userApi.get(
    `/ai/documents/${encodeURIComponent(bookingId)}/${encodeURIComponent(docId)}/download`,
    { responseType: "blob" }
  );

  const url  = URL.createObjectURL(response.data);
  const link = document.createElement("a");
  link.href     = url;
  link.download = fileName || "document";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
